/**
 * Created by andrey on 29.01.18.
 */

const LocationView = cc.Node.extend({
    ctor: function (page) {
        this._super();
        this.page = page;
        this.pageNo = page.pageNo;
        this.levels = [];
        this.bundle = bundles[this.getBundleName()];

        this.setAnchorPoint(0.5, 0.5);
        this.page.currentView = this;

        this.onResize();

        this.setLocalZOrder(-this.pageNo);
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getBgSize();
        const height = cleverapps.styles.LocationView.height;

        if (cleverapps.styles.LocationView.direction === cleverapps.UI.VERTICAL) {
            this.setPosition(sceneSize.width / 2, height * (this.pageNo + 1 / 2));
            this.bgScale = (height + cleverapps.styles.LocationView.addPixels) / height;
        } else {
            this.setPosition(sceneSize.width * (this.pageNo + 1 / 2), height / 2);
            this.bgScale = (sceneSize.width + cleverapps.styles.LocationView.addPixels) / sceneSize.width;
        }

        this.bg && this.bg.setScale(this.bgScale);
        this.updateScale();
    },

    customize: function () {
    },

    updateScale: function () {
        const styles = cleverapps.styles.LocationView;

        if (cleverapps.config.type === "board") {
            let scale = cleverapps.resolution.getSceneSize().width / (styles.Background.width + styles.padding);
            scale = Math.min(Math.max(styles.minScale, scale), 1);
            this.setScale(scale);
        }

        this.baseScaleX = this.scaleX;
        this.baseScaleY = this.scaleY;
    },

    onShow: function () {
        this.startLoadAnimation();

        const bundleNames = [this.page.getResourcesBundleId()];

        if (this.page.isComingSoon()) {
            bundleNames.push("episode_coming_soon");
        }

        const episodeBundles = bundleNames.filter((bundleName) => bundleName !== undefined && bundles[bundleName]);

        if (!episodeBundles.length) {
            this.onLoad();
            return;
        }

        this.loadedBundles = episodeBundles;

        cleverapps.bundleLoader.loadBundles(episodeBundles, {
            onSuccess: this.createListener(this.onLoad.bind(this)),
            onFailure: function () {
                this.loadedBundles = undefined;
            }.bind(this)
        });
    },

    onRemove: function () {
        this.removeLoadAnimation();
        this.removeFromParent();
    },

    onExit: function () {
        if (this.loadedBundles) {
            cleverapps.bundleLoader.deleteBundles(this.loadedBundles);
        }
    },

    addLevelsView: function () {
        if (cleverapps.config.rpg) {
            return;
        }

        const levelsView = new LevelsView(this.page);
        levelsView.setContentSize2(this.getContentSize());
        this.addChild(levelsView);

        levelsView.onLoad();
    },

    addBetweenEpisodesFlag: function () {
        let styles = cleverapps.styles.LevelsView;
        if (!styles.betweenEpisodesFlag || this.page.isComingSoon()) {
            return;
        }
        styles = styles.betweenEpisodesFlag;
        const positions = this.pageNo % 2 ? styles.levels_2 : styles.levels_1;
        if (!positions) {
            return;
        }

        const id = this.getBundleName();
        if (positions[id] === false) {
            return;
        }
        const flag = new cleverapps.Spine(styles.spine);
        flag.setAlignment(positions[id] ? positions[id] : positions.default);
        flag.setAnimation(0, this.pageNo < levels.user.currentPhysicalLevel.episode ? styles.passed : styles.notpassed, true);
        this.addChild(flag);
    },

    onLoad: function () {
        this.addDescription();
        this.finishLoadAnimation();

        this.addLevelsView();

        this.addBetweenEpisodesFlag();
        this.addTitle();

        this.customize();

        if (this.page.isComingSoon()) {
            this.addBackground();
            return;
        }

        if (cleverapps.config.name === "riddles" && cleverapps.bundleLoader.isLoaded(this.page.getResourcesBundleId())) {
            this.addSpines();
            this.addBackground();
        } else {
            this.addDefaultBackground();
        }

        this.addIsland();
    },

    addTitle: function () {
        if (typeof match3 !== "undefined") {
            return;
        }

        const toReplace = {
            episodeNo: (this.pageNo + 1)
        };

        const styles = cleverapps.styles.LocationView.title;
        let titleId = "EpisodeView.Title";
        if (this.page.isComingSoon()) {
            titleId = connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB)
                ? "EpisodeView.ComingSoonTitle.complete" : "EpisodeView.ComingSoonTitle";
        }

        if (styles.bg) {
            const titleBg = cleverapps.UI.createScale9Sprite(styles.bg.image);
            this.addChild(titleBg);
            titleBg.setAlignment(styles.bg);
            titleBg.setContentSize2(styles.bg);
        }

        // eslint-disable-next-line no-restricted-syntax
        const title = this.title = cleverapps.UI.generateTTFText(Messages.get(titleId, toReplace), cleverapps.styles.FONTS.EPISODE_TITLE_TEXT);
        if (styles.maxWidth) {
            title.fitTo(styles.maxWidth);
        }
        title.y = styles.y;
        this.addChild(title, 1);
    },

    addDescription: function () {
        if (cleverapps.config.type !== "board" || cleverapps.config.subtype === "stacks") {
            return;
        }

        const styles = cleverapps.styles.LocationView;

        let description;
        if (!this.page.isComingSoon() && this.bundle) {
            const minLength = this.bundle.meta.episode.minLength;
            const maxLength = this.bundle.meta.episode.maxLength;

            let difficulty = Math.round(minLength / 3 + maxLength / 2 - 2);
            if (difficulty < 1) {
                difficulty = 1;
            }
            if (difficulty > 5) {
                difficulty = 5;
            }
            difficulty = this.formatDifficulty(difficulty);

            let info = `${minLength} - ${maxLength}`;
            if (minLength === maxLength) {
                info = minLength;
            }

            // eslint-disable-next-line no-restricted-syntax
            description = cleverapps.UI.generateTTFText(Messages.get("EpisodeView.Description", {
                letters: info,
                difficulty
            }), cleverapps.styles.FONTS.DESCRIPTION_TEXT);
            description.fitTo(styles.Background.width * 0.90);
        } else {
            const comingSoonDescriptionId = connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB)
                ? "EpisodeView.ComingSoonDescription.complete" : "EpisodeView.ComingSoonDescription";
            // eslint-disable-next-line no-restricted-syntax
            description = cleverapps.UI.generateTTFText(Messages.get(comingSoonDescriptionId), cleverapps.styles.FONTS.DESCRIPTION_TEXT);
            description.fitTo(styles.Background.width * 0.90);
        }

        this.description = description;
        description.y = styles.description.y;
        this.addChild(description);
    },

    addBackground: function () {
        const bundleId = this.page.getResourcesBundleId();
        const bgUrl = bundles[bundleId] && bundles[bundleId].urls.background || this.bundle && this.bundle.urls.background;

        // word games
        if (!bgUrl) {
            return;
        }

        // was error loading in native
        if (cc.loader.getRes(bgUrl) === undefined) {
            console.log(`No bg image loaded, using default: ${bgUrl}`);
            this.addDefaultBackground();
            return;
        }

        if (this.bg) {
            this.bg.removeFromParent();
        }
        this.bg = new cc.Sprite(cc.loader.getRes(bgUrl));
        this.bg.setScale(this.bgScale);
        this.bg.setLocalZOrder(-1);
        this.addChild(this.bg);
    },

    addDefaultBackground: function () {
        if (typeof match3 === "undefined") {
            const styles = cleverapps.styles.LocationView.Background;

            this.bg = cleverapps.UI.createScale9Sprite(bundles.main.frames.episode_bg_png, cleverapps.UI.Scale9Rect.TwoPixelY);
            this.bg.setContentSize(styles.width, styles.height);
            this.bg.y = styles.y;
            this.bg.setLocalZOrder(-1);
            this.addChild(this.bg);
        } else if (bundles.main.urls.blank_bg_jpg) {
            this.bg = new cc.Sprite(bundles.main.urls.blank_bg_jpg);
            this.bg.setScale(2 * this.bgScale);
            this.bg.setLocalZOrder(-2);
            this.addChild(this.bg);
        }
    },

    addSpines: function () {
        const bundleId = this.page.getResourcesBundleId();
        if (!bundles[bundleId]) {
            return;
        }

        for (let i = 0; i < 10; i++) {
            const spineJson = bundles[bundleId].jsons[`spine_${i}_json`];

            if (!spineJson) {
                break;
            }
            const animation = new cleverapps.Spine(spineJson);
            const name = "animation";
            animation.setAnimation(0, name, true);
            animation.setLocalZOrder((this.pageNo === 0 && i === 2) ? -1 : 15);
            this.animation = animation;
            this.addChild(animation);
        }
    },

    addIsland: function () {
        const groupNo = Math.floor(this.pageNo / 10);
        const bundle = bundles[`episode_${groupNo}_island`];
        if (bundle && bundle.jsons[`island_${this.pageNo}_json`]) {
            const island = this.island = new IslandView(this.page, bundle);
            island.setLocalZOrder(3);
            this.addChild(island);
        }
    },

    removeLoadAnimation: function () {
        if (this.loading) {
            this.loading.finishAnimation();
            delete this.loading;
        }
    },

    startLoadAnimation: function () {
        if (!cleverapps.styles.LocationView.loadAnimation) {
            return;
        }

        if (cleverapps.silentIntro) {
            return;
        }

        const loading = this.loading = CloudsAnimation.factory();
        loading.setAlignment(this.width / 2, this.height / 2);
        loading.startLoadAnimation(this);
        this.addChild(loading);
    },

    formatDifficulty: function (difficulty) {
        return difficulty;
    },

    finishLoadAnimation: function () {
        if (!cleverapps.styles.LocationView.loadAnimation) {
            return;
        }

        if (cleverapps.silentIntro) {
            return;
        }

        if (this.loading) {
            if (!(typeof HoseSceneComponent !== "undefined" && cleverapps.Scenes.GetSceneComponent(HoseSceneComponent)) || !this.loading.visible) {
                this.removeLoadAnimation();
            } else {
                this.loading.finishLoadAnimation(this.removeLoadAnimation.bind(this));
            }
        }
    },

    getBundleName: function () {
        return `episode_${this.pageNo}`;
    }
});

cleverapps.styles.LocationView = {
    height: cleverapps.styles.SCENE_HEIGHT,

    addPixels: 2,

    direction: cleverapps.UI.HORIZONTAL,

    minScale: 0,
    padding: 0,

    Background: {
        width: 720,
        height: 1200
    },

    title: {
        y: 490
    },

    description: {
        y: 420
    },

    loadAnimation: false
};